/**
 * Web stub — native push lives in `PushNotifications.native.tsx`. Web push is
 * handled separately (Service Worker + VAPID), so this renders nothing and
 * keeps `expo-notifications` out of the web bundle.
 */
export function PushNotifications(): null {
  return null;
}
